import { useState, useEffect, useCallback } from 'react';
import { getFavoritesBiddings } from "../components/api"
import { BiddingListItem } from "../components/BiddingListItem"
import '../styles/bidding-list.scss';
import { useUnit } from 'effector-react';
import { $isAuth } from '../store';

export const FavoriteBiddings = () => {
    const [biddings, setBiddings] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [removingId, setRemovingId] = useState(null);

    const isAuth = useUnit($isAuth);

    const biddingsLimit = 8;

    const loadMoreBiddings = useCallback(async () => {
        if (loading || !hasMore) return;
        setLoading(true);

        try {
            const data = await getFavoritesBiddings(biddingsLimit, page * biddingsLimit);

            if (data && data.length > 0) {
                setBiddings(prevBiddings => [...prevBiddings, ...data]);
                setPage(prevPage => prevPage + 1);
                if (data.length < biddingsLimit) {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Ошибка получения торгов:", error);
        } finally {
            setLoading(false);
        }
    }, [loading, hasMore, page, biddingsLimit]);

    useEffect(() => {
        loadMoreBiddings();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100
            ) {
                loadMoreBiddings();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadMoreBiddings]);

    const goToBiddingCard = (id) => {
        if (isAuth) {
            window.location.href = `/bidding/${id}?returnUrl=${window.location.pathname}`;
        }
    }

    const handleFavoriteChange = (id, isFavorite) => {
        if(!isFavorite){
            setRemovingId(id);
            setTimeout(() => {
                setBiddings(prevBiddings => prevBiddings.filter(bidding => bidding.id !== id));
                setRemovingId(null);
            }, 500);
        }
    }

    return (
        <div className='bidding-list'>
            <h2>Избранные аукционы</h2>
            {biddings.map(bidding => (
                <BiddingListItem
                    key={bidding.id}
                    data={bidding}
                    status={"completed"}
                    onClick={() => goToBiddingCard(bidding.id)}
                    onFavoriteChange={handleFavoriteChange}
                    removing={removingId === bidding.id}
                />
            ))}
            {loading && <p>Загрузка...</p>}
            {!hasMore && !loading && <p style={{ textAlign: 'center' }}> </p>}
        </div>
    )
};